import {useTranslation} from '@aboutyou/i18n';
import React, {FC} from 'react';
import styled from 'styled-components';
import {COLORS} from '../../../../constants/colors';
import {Button, ButtonProps} from '../../../atoms/Buttons/Button';

/**
 * @deprecated This component is deprecated because it violates best practices defined in the @aboutyou/ui-components.
 */
export const BasketLoginButton: FC<{
  onClick?: ButtonProps['onClick'];
  dataTestId: string;
}> = ({onClick, dataTestId}) => {
  const {t} = useTranslation();

  return (
    <StyledLoginButton
      disableShadow
      type={'secondary'}
      onClick={onClick}
      data-testid={dataTestId}
    >
      {t('Log in')}
    </StyledLoginButton>
  );
};

const StyledLoginButton = styled(Button)`
  border: 1px solid ${COLORS.Grey3};
`;
